const React = require('react');
const createReactClass = require('create-react-class');

let PendingPool = {};
let ReadyPool = {};

const ImageFormatter = createReactClass({
  getInitialState() {
    return {
      ready: false,
    };
  },

  componentWillMount() {
    this._load(this.props.value);
  },

  componentWillReceiveProps(nextProps) {
    if (nextProps.value !== this.props.value) {
      this.setState({ value: null });
      this._load(nextProps.value);
    }
  },

  _load(src) {
    let imageSrc = src;
    if (ReadyPool[imageSrc]) {
      this.setState({ value: imageSrc });
      return;
    }

    if (PendingPool[imageSrc]) {
      PendingPool[imageSrc].push(this._onLoad);
      return;
    }

    PendingPool[imageSrc] = [this._onLoad];

    let img = new Image();
    img.onload = () => {
      PendingPool[imageSrc].forEach(callback => {
        callback(imageSrc);
      });
      delete PendingPool[imageSrc];
      img.onload = null;
      imageSrc = undefined;
    };
    img.src = imageSrc;
  },

  _onLoad(src) {
    if (this.isMounted() && src === this.props.value) {
      this.setState({
        value: src,
      });
    }
  },

  render() {
    var style = this.props.value
      ? {
          backgroundImage: 'url(api/resources/images/' + this.props.value + '?max_width=40&max_height=40)',
        }
      : undefined;

    return <div className="react-grid-image" style={style} />;
  },
});

module.exports = ImageFormatter;
